import {markdownToHTML} from "../utils/text";
import { buildUpdator } from '../carto/shared';
import { CustomShapes } from './custom_shapes';

function getContextMenuContent(data, item) {
  if (!data.context) {
    return "";
  }

  return `
  <div style="margin:auto; padding: 10px; text-align: left;">
    ${markdownToHTML(data.context)}
  </div>
  `;
}


// External editor at https://apps.zoomcharts.com/graph-editor/
// netchart = Nedit.nc (netchart._impl.settings netchart._impl.layer.style)

function initializeMap(data, {element, height, focus_nodes, onClick, layout, linkStyle, auras, onFullScreen}) {
  const updator = buildUpdator(element);

  const orthogonalOffset = {straight: 0, orthogonal: 0.5, curved: 0}[linkStyle];

  function onHoverChange(e) {
    const node = e.hoverNode;
    if (node?.data?.info) {
      updator.onHoverChange({
        hoverNode: node,
        force_text: node.data.info,
        x: e.x,
        y: e.y
      })
    } else {
      updator.onHoverChange({ hoverNode: null });
    }
  }

  const opts = focus_nodes ? {
    navigation: {
      mode: "focusnodes",
      // mode: "manual",
      initialNodes: focus_nodes,
      // focusNodeExpansionRadius: 5,
      initialFocusNodeExpansionRadius: 1,
      autoUnfocus: false,
      // numberOfFocusNodes: 2,
      expandOnClick: true
      // defaultExpandDepth: 2,
    }
  } : {
    navigation: {mode: "showall"}
  };

  const toolbar = {
    fullscreen: false,
    freeze: false,
    sticky: false,
    rearrange: false,
    back: false,
    extraItems: [{
      label: "fullScreen",
      title: "fullScreen",
      align: "left",
      side: "bottom",
      cssClass: "custom-zoomchart-fullscreen-bar-btn",
      onClick: function(e, chart){
	onFullScreen(chart)
	e.preventDefault();
      }
    }]
  };


  const chart = new window.NetChart({
    navigation : opts.navigation,
    container: element,
    area: {
      // height: height,
      style: { fillColor: "white" }
    },
    data: { preloaded: data },
    layout,
    auras,
    toolbar,
    nodeMenu: {
      contentsFunction: getContextMenuContent
    },

    style: {
      // https://zoomcharts.com/developers/en/net-chart/api-reference/settings/style/item.html
      item: {
        scale: 0.6,
        scaleWithSize: true,
        hoverEffect: false
      },
      node: {
        display: "image",
        imageCropping: true,
        cursor: "pointer"
      },
      nodeFocused: {},
      nodeSelected: {},
      selection: {
        enabled: false,
      },
      nodeDetailMinSize: 0,
      nodeDetailMinZoom: 0,
      // linkDetailMinSize: 100,
      linkDetailMinZoom: 2.2,
      nodeStyleFunction: nodeStyle,
      linkStyleFunction: linkStyleFunction,

      link: {
	orthogonalOffset
      },

      // https://zoomcharts.com/developers/en/net-chart/api-reference/settings/style/linkLabel/textStyle.html
      linkLabel:{
        // borderRadius: 999,  //make as round as possible
        align: "center",
        // textStyle:{font:"12px Arial", fillColor: "white"},
        // backgroundStyle:{fillColor:"rgba(86,185,247,0.8)", lineColor:"rgba(28,124,213,0.9)"},
        // scaleWithSize: true,
        // scaleWithZoom: true, // default true
        // aspectRatio: 4, // default 4
        textStyle: {
          font: "18px Manrope-Medium",
        },
	backgroundStyle: {
	  lineWidth: 1
	},
	padding: 1
      },
      nodeLabel: {
        textStyle: {
          font: "12px Manrope-Medium",
        },
	backgroundStyle: {
	    fillColor: "rgba(0,0,0,.1)"
	},
	padding: 1
      },
      // linkLabelScaleBase: 1.3,
    },
    events: {
      onHoverChange,
      onClick: (e) => {
        if (e.clickNode) {
          // console.log(e.clickNode);
          onClick(e.clickNode.data);
        }
      }
    },
    legend: {
      enabled: true,
      padding: 6,
      marker: { size: 22 },
      maxLineSymbols: 12
    }
  });

  function nodeStyle(node) {
    const {
      bound_to_ce,
      label,
      // info,
      // context,
      aura,
      // style: { shape, fillColor, radius, aspectRatio, lineColor, lineDash, lineWidth, opacity }
      style: {
	selected_shape
      }
    } = node.data;

    node.aura = aura;
    // node.display = shape;
    // radius && (node.radius = radius);
    let items = node.items = [];

    // https://zoomcharts.com/developers/en/net-chart/examples/style/builtin-node-shapes.html
    // https://zoomcharts.com/developers/en/net-chart/examples/style/custom-node-shapes.html
    const builtin_shapes = ["circle", "image", "rectangle", "text", "roundtext", "droplet"];
    const custom_shapes = ["rect", "diamond", "hexagon"]; // "rhombus"

    if (builtin_shapes.includes(selected_shape)) {
      node.display = selected_shape;
      node.label = label;
    } else if (custom_shapes.includes(selected_shape)) {
      node.display = "customShape";
      node.customShape = CustomShapes[selected_shape];
      if (label) {
	// taken from reverse enverining
	items.push({
	  text: label.replace(/[\n\r]+/, "<br>"),
	  aspectRatio: 0,
	  px: 0,
	  py: 1,
	  y: 6,
	  textStyle: {
	    fillColor: "black"
	  },
	  backgroundStyle: {
	      fillColor: "rgba(0,0,0,.1)"
	  },
	  padding: 1
	})
      }
    } else {
      console.log("Unknown shape: " + selected_shape)
    }

    /*
    fillColor && (node.fillColor = fillColor);
    aspectRatio && (node.aspectRatio = aspectRatio);
    lineColor && (node.lineColor = lineColor);
    lineDash && (node.lineDash = lineDash);
    lineWidth && (node.lineWidth = lineWidth);
    opacity && (node.opacity = opacity);
    */

    // https://zoomcharts.com/developers/en/net-chart/introductory-topics/items.html
    // https://zoomcharts.com/developers/en/net-chart/api-reference/settings/style/node/items.html
    if (bound_to_ce) {
      items.push({
	px: -0.7, py: -0.7, x: 0, y: 0,
	scaleWithSize: false,
	image: window.PUBLIC_URL + "/reticular-rp-rouge.32x32.png"
      })
    }
  }

  function linkStyleFunction(link) {
    const {
      label,
      fromDecoration,
      toDecoration,
      fillColor,
      radius,
      lineDash,
      // orthogonal related
      definesLayout,
      orthogonalOffset,
      arcAmount,
      arcOffset
    } = link.data;

    // todo: radius!

    link.label = label;
    link.fromDecoration = fromDecoration;
    link.toDecoration = toDecoration;
    if (radius) {
      link.radius = radius;
    }

    link.lineDash = lineDash;

    link.fillColor = fillColor;

    link.labelStyle.backgroundStyle = {
      fillColor
      // lineColor: "#333"
    }

    link.definesLayout = definesLayout;

    link.orthogonalOffset = linkStyle === "orthogonal" ? orthogonalOffset : null;

    if (linkStyle === "curved") {
      if (arcAmount !== "undefined" && arcAmount >= -200 && arcAmount <= 200) {
	link.arcAmount = arcAmount;
      } else {
	link.arcAmount = 0;
      }
      if (arcOffset !== "undefined" && arcOffset >= -1 && arcOffset <= 1) {
	link.arcOffset = arcOffset;
      } else {
	link.arcOffset = 0;
      }
    }
    else {
      link.arcAmount = 0;
      link.arcOffset = 0;
    }
  }

  updator.setChart(chart);

  return {chart};
}

export default initializeMap;
